import request from '@/utils/request'


// 查询勋章列表
export function listMedal(query) {
  return request({
    url: '/joe/medal/list',
    method: 'get',
    params: query
  })
}

// 查询勋章分页
export function pageMedal(query) {
  return request({
    url: '/joe/medal/page',
    method: 'get',
    params: query
  })
}


export function changeIsOpen(data) {
  return request({
    url: '/joe/medal/changeIsOpen',
    method: 'post',
    data: data
  })
}


// 查询勋章详细
export function getMedal(data) {
  return request({
    url: '/joe/medal/detail',
    method: 'get',
    params: data
  })
}

// 新增勋章
export function addMedal(data) {
  return request({
    url: '/joe/medal/add',
    method: 'post',
    data: data
  })
}

// 修改勋章
export function updateMedal(data) {
  return request({
    url: '/joe/medal/edit',
    method: 'post',
    data: data
  })
}

// 删除勋章
export function delMedal(data) {
  return request({
    url: '/joe/medal/delete',
    method: 'post',
    data: data
  })
}
